import type { GetStaticPaths, GetStaticProps } from "next"
import { type AuthorArchiveProps, getAuthorArchive } from "@/components/resources/data/archives"
import { AUTHORS, isAuthorSlug } from "@/components/resources/data/markdown/authors"
import { SiteLayout } from "@/components/resources/layouts/site"
import { AuthorPage } from "@/components/resources/templates/AuthorPage"

const AuthorPosts = (props: AuthorArchiveProps) => <AuthorPage {...props} />

AuthorPosts.getLayout = SiteLayout

export default AuthorPosts

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: Object.keys(AUTHORS).map((slug) => ({ params: { slug } })),
  fallback: false,
})

export const getStaticProps: GetStaticProps<AuthorArchiveProps, { slug: string }> = async ({
  params,
}) => {
  const slug = params?.slug
  const props = slug && isAuthorSlug(slug) ? await getAuthorArchive(slug, 1) : null
  return props ? { props, revalidate: 180 } : { notFound: true }
}
